import { AccountDetailsContext } from "core/cuenta/contexts/AccountDetailsContext";
import { MovimientoCuenta } from "core/models/data/MovimientoCuenta";
import { SearchAccountMovementsRequest } from "core/models/SearchAccountMovementsRequest";
import { useCoreService } from "core/services/useCoreService";
import { useContext } from "react";
import { withPagination } from "shared/table/hoc/withPagination";
import { Pageable } from "shared/table/models/Pageable";
import { AccountMovementsTable } from "../AccountMovementsTable/AccountMovementsTable";

const TableWithPagination = withPagination<MovimientoCuenta>(AccountMovementsTable);

export const AccountMovementsTableWithPagination = (props: {
  movimientos: Pageable<MovimientoCuenta>;
}) => {
  const { accountData } = useContext(AccountDetailsContext);
  const coreService = useCoreService();

  const onChangePaginationStatus = async (status: {
    pageNumber: number;
    pageSize: number;
  }): Promise<Pageable<MovimientoCuenta>> => {
    const searchParams = new SearchAccountMovementsRequest({
      nroCuenta: accountData.nroCuenta,
      page: status.pageNumber,
      size: status.pageSize,
    });
    const response = await coreService.getAccountMovements(searchParams);
    return response.body;
  }

  return (
    <TableWithPagination
      pageableInit={props.movimientos}
      dataFetcherFunction={onChangePaginationStatus}
    ></TableWithPagination>
  );
};
